module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sessionEndMessage":"Are you still there?","header":"Are you still there?","option1":"I\u0027m still here","option2":"Start Over","endIn":"Your session will timeout in ","unit":" seconds"},"es":{"sessionEndMessage":"¿Sigues ahí?","header":"¿Sigues ahí?","option1":"Todavía Estoy Aquí","option2":"Comenzar de Nuevo","endIn":"Su sesión expirará en ","unit":" segundos"}}')
  delete Component.options._Ctor
}
